import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const Github: React.FC = () => (
  <StyledNetworkItem
    href="https://github.com/nominex"
    target="_blank"
    rel="noreferrer noopener"
    className="text-brand-github"
  >
    <SlIcon library="social" name="github" />
  </StyledNetworkItem>
)

export default Github
